import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Nav from "@/components/Nav";
import { useAuth } from "@/context/AuthContext";
import Seo from "@/components/Seo";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await login(email, pw);
    setBusy(false);
    if (res.ok) { toast.success("Welcome back"); nav("/dashboard"); }
    else toast.error(res.error);
  };

  return (
    <div className="min-h-screen bg-linen">
      <Seo title="Sign in" path="/login" noindex />
      <Nav />
      <div className="max-w-md mx-auto px-5 py-16">
        <h1 className="font-serif text-4xl text-forest">Welcome back</h1>
        <p className="text-forest/70 mt-2">Sign in to manage bookings and messages.</p>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
          <div>
            <label className="text-[11px] tracking-[0.12em] uppercase text-forest/60">Email</label>
            <input type="email" required autoComplete="email" autoCapitalize="none" autoCorrect="off" spellCheck="false" value={email} onChange={(e) => setEmail(e.target.value)} className="input-organic mt-1" data-testid="login-email" />
          </div>
          <div>
            <label className="text-[11px] tracking-[0.12em] uppercase text-forest/60">Password</label>
            <input type="password" required autoComplete="current-password" value={pw} onChange={(e) => setPw(e.target.value)} className="input-organic mt-1" data-testid="login-password" />
          </div>
          <button disabled={busy} className="btn-primary w-full disabled:opacity-60" data-testid="login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>
          <p className="text-sm text-forest/70 text-center">
            <Link to="/forgot-password" className="text-forest underline underline-offset-4" data-testid="forgot-link">Forgot your password?</Link>
          </p>
          <p className="text-sm text-forest/70 text-center">
            New here? <Link to="/register" className="text-forest underline underline-offset-4">Create an account</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
